import { z } from "zod";
import { IsoDateTimeSchema } from "./common.js";

export const ProfileSubjectSchema = z.enum(["agent", "owner"]);

export const ProfileIdentitySchema = z
  .object({
    subject: ProfileSubjectSchema,
    displayName: z.string().min(1).max(80),
    avatarUrl: z.string().max(400).nullable(),
    avatarUpdatedAt: IsoDateTimeSchema.nullable(),
  })
  .strict();

export const ProfileSettingsSchema = z
  .object({
    agent: ProfileIdentitySchema,
    owner: ProfileIdentitySchema,
    /** HerSkin 登录账号。它与 owner.displayName（对话显示名称）相互独立。 */
    loginUsername: z.string().min(2).max(80),
    updatedAt: IsoDateTimeSchema,
  })
  .strict();

export const UpdateProfileIdentityRequestSchema = z
  .object({
    displayName: z
      .string()
      .trim()
      .min(1, "显示名称不能为空")
      .max(40, "显示名称最多 40 个字符")
      .refine(
        (value) =>
          !Array.from(value).some((character) => {
            const code = character.charCodeAt(0);
            return code < 32 || code === 127;
          }),
        "显示名称不能包含控制字符",
      ),
  })
  .strict();

export const UpdateCredentialsRequestSchema = z
  .object({
    currentPassword: z.string().min(1).max(1024),
    username: z
      .string()
      .trim()
      .min(2)
      .max(80)
      .regex(/^[A-Za-z0-9._-]+$/u, "账号只能包含字母、数字、点、下划线和短横线"),
    newPassword: z.string().min(12).max(1024).nullable(),
  })
  .strict();

export const UpdateCredentialsResponseSchema = z
  .object({
    updated: z.literal(true),
    requiresLogin: z.literal(true),
  })
  .strict();

export const AvatarMutationResponseSchema = z
  .object({
    profile: ProfileSettingsSchema,
  })
  .strict();

export const ProfileIdentityMutationResponseSchema = AvatarMutationResponseSchema;

export type ProfileSubject = z.infer<typeof ProfileSubjectSchema>;
export type ProfileIdentity = z.infer<typeof ProfileIdentitySchema>;
export type ProfileSettings = z.infer<typeof ProfileSettingsSchema>;
export type UpdateProfileIdentityRequest = z.infer<typeof UpdateProfileIdentityRequestSchema>;
export type UpdateCredentialsRequest = z.infer<typeof UpdateCredentialsRequestSchema>;
export type UpdateCredentialsResponse = z.infer<typeof UpdateCredentialsResponseSchema>;
export type AvatarMutationResponse = z.infer<typeof AvatarMutationResponseSchema>;
export type ProfileIdentityMutationResponse = z.infer<typeof ProfileIdentityMutationResponseSchema>;
